// extracted by mini-css-extract-plugin
module.exports = {"hoverTriger":"Navbar_hoverTriger__pU71w","hoverTarget":"Navbar_hoverTarget__zls4N"};